import { useTranslation } from 'react-i18next';
import { PopupOverlay } from '@/components/ui/PopupOverlay';

export interface LeaveWizardPopupProps {
  visible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

export function LeaveWizardPopup({
  visible,
  onConfirm,
  onCancel,
  isLoading = false,
}: LeaveWizardPopupProps) {
  const { t } = useTranslation();

  return (
    <PopupOverlay
      visible={visible}
      title={t('onboarding.leaveWizard.title')}
      body={t('onboarding.leaveWizard.body')}
      confirmLabel={t('onboarding.leaveWizard.confirm')}
      cancelLabel={t('onboarding.leaveWizard.cancel')}
      onConfirm={onConfirm}
      onCancel={onCancel}
      confirmLoading={isLoading}
      testID="leave-wizard-popup"
    />
  );
}
